<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :onClose="onClose">
    <div class="row" v-if="contractData">
      <div class="col-4">
        <div class="generalTitleItemModal">Contrato</div>
        <a href="#" @click="downloadContrato('contract')">
          <v-icon name="bi-download" scale="1.2" />
          &nbsp;
          <span class="text-muted"> {{ $store.state.roles.Backoffice_member_empresas ? $dateBackToFront(contractData.transDate, true) : $dateBackToFront(contractData.date, true) }}</span>
        </a>
        <template v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="generalTitleItemModal">Anexo Contrato</div>
          <a href="#" @click="downloadContrato('annex')">
            <v-icon name="bi-download" scale="1.2" />
            &nbsp;
            <span class="text-muted"> {{ $dateBackToFront(contractData.transDate, true) }}</span>
          </a>
        </template>
        <template v-if="$store.state.roles.Backoffice_member_empresas" class="mt-2">
          <div class="generalTitleItemModal">Propuesta</div>
          <a href="#" @click="downloadContrato('proposal')">
            <v-icon name="bi-download" scale="1.2" />
            &nbsp;
            <span class="text-muted">Descargar</span>
          </a>
        </template>
        <div v-if="!$store.state.roles.Backoffice_member_empresas" class="mt-2">
          <div class="generalTitleItemModal">Documento de Recogida</div>
          <a href="#" @click="downloadDocumentoRecogida()">
            <v-icon name="bi-download" scale="1.2" />
            &nbsp;
            <span class="text-muted">Descargar</span>
          </a>
        </div>
        <div v-if="!$store.state.roles.Backoffice_member_empresas">
          <div v-if="renewalId !== ''" class="mt-2">
            <div class="generalTitleItemModal">Renovación</div>
              <a href="#" @click="downloadRenewal()">
                <v-icon name="bi-download" scale="1.2" />
                &nbsp;
                <span class="text-muted">{{ renewalId }}</span>
              </a>
          </div>
          <div v-if="cancellationId !== ''" class="mt-2">
            <div class="generalTitleItemModal">Cancelación</div>
              <a href="#" @click="downloadCancellation()">
                <v-icon name="bi-download" scale="1.2" />
                &nbsp;
                <span class="text-muted">{{ cancellationId }}</span>
              </a>
          </div>
          <div v-if="contractFinish" class="mt-2">
            <div class="generalTitleItemModal">Finalización del contrato</div>
              <a href="#" @click="downloadContractFinish()">
                <v-icon name="bi-download" scale="1.2" />
                &nbsp;
                <span class="text-muted">Descargar</span>
              </a>
          </div>
        </div>
        <div v-if="receiptDesisted" class="mt-2">
          <div class="generalTitleItemModal">Documento de Desistimiento</div>
            <a href="#" @click="downloadDesistedDocument()">
              <v-icon name="bi-download" scale="1.2" />
              &nbsp;
              <span class="text-muted">Descargar</span>
            </a>
        </div>
        <template v-if="additionalsReceipts.length > 0">
          <div class="mt-2" v-for="(additionalReceipt, index) in additionalsReceipts" :key="index">
            <div class="generalTitleItemModal">
              <template v-if="additionalReceipt.type === 'CANCEL'">Recibo de cancelación</template>
              <template v-if="additionalReceipt.type === 'RENEWAL'">Recibo de renovación</template>
              <template v-if="additionalReceipt.type === 'DAMAGE'">Recibo de desperfecto</template>
            </div>
            <a href="#" @click="downloadAdditionalReceipt(additionalReceipt.type)">
              <v-icon name="bi-download" scale="1.1" />
              &nbsp;
              <span class="text-muted">{{$dateBackToFront(additionalReceipt.paymentDate, true)}}</span>
            </a>
          </div>
        </template>
        <div class="mt-2">
          <div class="generalTitleItemModal">Pegatinas</div>
          <div v-if="Array.isArray(tags) && tags.length > 0">
            <div style="display: flex; flex-direction: column;" v-for="(tag, index) in tags" v-bind:key="index">
              <!-- Para empresas: descarga directa sin IMEI -->
              <a v-if="$store.state.roles.Backoffice_member_empresas" :href="tag.tag" target="_blank">
                <v-icon name="bi-download" scale="1.2" />&nbsp;
                <span class="text-muted">{{ tag.contractId + ' - ' + $dateBackToFront(tag.dateTag, true) }}</span>
              </a>
              <!-- Para retail: proceso con IMEI -->
              <template v-else>
                <a href="#" @click="showTags(index)">
                  <v-icon name="bi-download" scale="1.2" />&nbsp;
                  <span class="text-muted">{{ tag.contractId + ' - ' + $dateBackToFront(tag.dateTag, true) + ' - ' + tag.partCode }}</span>
                </a>
                <a :href="tag.tag" target="_blank" :id="tag.contractId+'-'+index" style="display: none;" v-if="tag.showLink">
                </a>
                <div v-if="tag.show" style="display: flex;">
                  <div>
                    <input style="width: 18ch;"
                      type="text"
                      class="form-control generalInput"
                      id={{tag.contractId}}
                      placeholder="IMEI"
                      v-model.trim="tags[index].imei"
                    />
                    <small class="form-text text-danger" v-if="tags[index].imei == '' || tags[index].imei <= 0">Debe ser un número positivo</small>

                  </div>
                  <button @click="dowloadTag(index, tag)" class="btn btn-primary generalPrimaryButton">Descargar</button>
                </div>
              </template>
            </div>
          </div>
          <div v-else class="alert alert-light p-0">
            Todavía no hay pegatinas
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="generalTitleItemModal">Recibos</div>
        <div v-if="contractData.receipts">
          <div class="row" v-for="recibo in contractData.receipts" :key="recibo.number">
            <a href="#" @click="downloadContrato('receipt',recibo.number)">
              <v-icon name="bi-download" scale="1.1" />
              &nbsp;
              <span class="text-muted">{{recibo.number}}ª factura ({{recibo.paymentDate}})</span>
            </a>
          </div>
        </div>
        <div v-else class="alert alert-light p-0">
          Todavía no hay recibos
        </div>
      </div>
      <div v-if="!$store.state.roles.Backoffice_member_empresas" class="col-4">
        <div class="generalTitleItemModal">Recobros</div>
        <div v-if="contractData.receipts">
          <div class="row" v-for="recibo in contractData.receipts" :key="recibo.number">
            <a v-if="recibo.paymentDateCommission !== null" href="#" @click="downloadRecobro(recibo.number)">
              <v-icon name="bi-download" scale="1.1" />
              &nbsp;
              <span class="text-muted">{{recibo.number}}ª recobro ({{recibo.paymentDateCommission}})</span>
            </a>
          </div>
        </div>
        <div v-else class="alert alert-light p-0">
          No hay recobros
        </div>
      </div>
      <div v-if="$store.state.roles.Backoffice_member_empresas" class="col-4">
        <div class="generalTitleItemModal">Documento de Recogida</div>
        <a href="#" @click="downloadDocumentoRecogida()">
          <v-icon name="bi-download" scale="1.2" />
          &nbsp;
          <span class="text-muted">Descargar</span>
        </a>
      </div>
    </div>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>

<script>

import Modal from '../../../Shared/Modal.vue';
import axios from 'axios';
export default {
  name: 'Documents',
  props: [
    'id',
    'modalTitle',
    'class',
    'contractId'
  ],
  data() {
    return {
      classes: this.class,
      contractData: '',
      tags: [],
      renewalId: "",
      cancellationId: "",
      contractFinish: false,
      receiptDesisted: false,
      additionalsReceipts: [],
    };
  },
  mounted() {
    this.loadContractData();
  },
  components: {
    Modal,
  },
  methods: {
    loadContractData() {
      let urlContratos = "/contract/";
      if (this.$store.state.roles.Backoffice_member_empresas)
        urlContratos = "/business" + urlContratos + "get-contract/";
      axios.get(urlContratos + this.contractId).then((response) => {
        this.contractData = response.data;
        if (!this.$store.state.roles.Backoffice_member_empresas) {
          // RENOVATED, EARLY_RENEWED
          if(["RENOVATED","EARLY_RENEWED"].includes(response.data.status)) {
            axios.get(`/contract-renewal/search?parentContractId=${this.contractId}`)
            .then((response) => {
              if(response.data.renewals[0]) {
                this.renewalId = response.data.renewals[0].renewalId
              }
            }).catch( error => console.log(error));
          }
          // CANCELED_BY_CUSTOMER
          if(response.data.status === "CANCELED_BY_CUSTOMER") {
            axios.get(`/contract/request/cancellation/search?contractId=${this.contractId}&page=1&pageSize=25`)
            .then((response) => {
              if(response.data.responseCancellations[0]) {
                this.cancellationId = response.data.responseCancellations[0].requestCancellationId
              }
            }).catch( error => console.log(error));
          }
          // FINISHED_AND_PURCHASE
          if(response.data.status === "FINISHED_AND_PURCHASE") {
            this.contractFinish = true;
          }
        }

        // DESISTED
        if(response.data.status === "DESISTED") {
          this.receiptDesisted = true;
        }

        // additionalsReceipts
        axios.get(`/receipt/${this.contractId}/additional-receipts`)
          .then((response) => {
            if(Array.isArray(response.data) && response.data.length > 0) {
              this.additionalsReceipts = response.data;
            }
          }).catch( error => {
            // 404 es normal cuando no hay recibos adicionales
            if (error.response?.status !== 404) {
              console.error('Error al cargar recibos adicionales:', error);
            }
          });

      }).catch( error => console.log(error));

      let urlTags = "/contract/logistics/tags/";
      if (this.$store.state.roles.Backoffice_member_empresas){
        urlTags = "/business/tags-delivery/";
      }
      axios.get(urlTags + this.contractId).then((response) => {

          response.data.tags.forEach((element) => {
            element.tag = element.tag.replace(/"/g,'');
            element.show = false;
            element.showLink = false;
            element.imei = '';
          });
          this.tags = response.data.tags;

      }).catch( error => console.log(error));
    },

    downloadContrato(type,month) {
      let urlDocument="";
      switch (type) {
        case 'contract':
          if(this.$store.state.roles.Backoffice_member_empresas) {
            urlDocument=`/contract/business/documents/${this.contractId}/CONTRACT`;
          } else {
            urlDocument=`/contract/document/${this.contractId}`;
          }
          break;
        case 'annex':
          urlDocument=`/contract/business/documents/${this.contractId}/ANNEX`;
          break;
        case 'proposal':
          urlDocument=`/contract/business/documents/${this.contractId}/PROPOSAL`;
          break;
        case 'receipt':
          if(this.$store.state.roles.Backoffice_member_empresas) {
            urlDocument=`/contract/business/document/${this.contractId}/receipt/${month}`;
          } else {
            urlDocument=`/contract/document/${this.contractId}/receipt/${month}`;
          }
          break;
        default:
          return null;
      }

      if(urlDocument != ""){
        axios.get(urlDocument)
        .then((response) => {
          window.open(response.data, '_blank');
        });
      }
    },
    downloadRecobro(month) {
      axios.get(`/contract/document/commission/${this.contractId}/receipt/${month}`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    },
    downloadDocumentoRecogida() {
      axios.get(`/contract/document/${this.contractId}/delivery-document`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    },
    showTags(index){
      this.tags.forEach((element, i) => {
        if(index === i) {
          element.show = !element.show;
          element.imei = '';
          element.showLink = false;
        } else {
          element.show = false;
          element.imei = '';
          element.showLink = false;
        }
      });
    },



    async dowloadTag(i, tag) {
      if (this.tags[i].imei == '' || this.tags[i].imei <= 0) {
        console.log("El IMEI debe ser un número positivo.");
        return;
      }


      // Determinar estructura de datos según tipo de usuario
      const isBusinessUser = this.$store.state.roles.Backoffice_member_empresas;
      let legalIdentifier, partCode, imei, contractId;

      if (isBusinessUser) {
        // Para contratos de empresas
        // Buscar CIF en todas las ubicaciones posibles
        legalIdentifier = this.contractData.cif
                       || this.contractData.legalIdentifier
                       || this.contractData.companyLegalIdentifier
                       || this.contractData.businessCustomer?.legalIdentifier
                       || this.contractData.businessCustomer?.cif
                       || '';

        // Para empresas, el partCode puede estar en orderedProducts o deliveryAddress
        partCode = this.contractData.partCode
                || this.contractData.orderedProducts?.[0]?.partCode
                || this.contractData.deliveryAddress?.partCode
                || this.contractData.product?.partCode
                || '';

        imei = this.tags[i].imei;

        // Para empresas usar businessContractId que es el formato E00000300
        contractId = this.contractData.businessContractId
                  || tag.contractId
                  || this.contractData.contractId;
      } else {
        // Para contratos normales
        legalIdentifier = this.contractData.customer?.legalIdentifier || '';
        partCode = this.contractData.product?.partCode || '';
        imei = this.contractData.product?.imei || this.tags[i].imei;
        contractId = this.contractData.contractId || tag.contractId;
      }

      // Para empresas, el backend podría esperar campos diferentes
      const payload = isBusinessUser ? {
        "backOfficeUser": this.$cookies.get("username") || '',
        "businessContractId": contractId,
        "dni": legalIdentifier,
        "partCode": partCode,
        "imei": imei,
      } : {
        "backOfficeUser": this.$cookies.get("username") || '',
        "contractId": contractId,
        "dni": legalIdentifier,
        "partCode": partCode,
        "imei": imei,
      };

      console.log('Payload for logistics-tracking:', payload);

      // Validar que todos los campos requeridos estén presentes
      const contractIdField = isBusinessUser ? payload.businessContractId : payload.contractId;
      if (!contractIdField || !payload.dni || !payload.partCode || !payload.imei) {
        const missingFields = [];
        if (!contractIdField) missingFields.push(isBusinessUser ? 'businessContractId' : 'contractId');
        if (!payload.dni) missingFields.push('DNI/CIF');
        if (!payload.partCode) missingFields.push('partCode');
        if (!payload.imei) missingFields.push('IMEI');
        console.error('Faltan datos requeridos:', missingFields.join(', '));
        console.error('Datos incompletos en payload:', payload);
        console.error('contractData disponible:', this.contractData);
        return;
      }

      try {
        const response = await axios.post('/logistics-tracking', payload);
        if (response.status === 200) {
          console.log('Contrato actualizado correctamente');
          // Lógica para descargar la etiqueta
          this.tags[i].showLink = true;
          this.$nextTick(() => {
            document.querySelector(`#${tag.contractId}-${i}`).click();
          });
          this.$nextTick(() => {
            this.tags[i].showLink = false;
            this.tags[i].show = false;
            this.tags[i].imei = '';
          });
        } else {
          console.error('Error al actualizar el contrato:', response.data);
        }
      } catch (error) {
        console.error('Ha ocurrido un error al actualizar el contrato:', error);
        console.error('Response data:', error.response?.data);
        console.error('Response status:', error.response?.status);
      }
    },
    downloadRenewal() {
      axios.get(`/contract-renewal/${this.renewalId}/receipt`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    },
    downloadCancellation() {
      axios.get(`/contract/request/cancellation/${this.cancellationId}/receipt`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    },
    downloadContractFinish() {
      axios.get(`/contract/finished/document/${this.contractId}/receipt`)
        .then((response) => {
          window.open(response.data, '_blank');
        });
    },
    downloadAdditionalReceipt(type) {
      axios.get(`/receipt/${this.contractId}/additional-receipts/pdf?type=${type}`)
        .then((response) => {
          window.open(response.data.temporaryLink, '_blank');
        });
    },
    downloadDesistedDocument() {
      axios.get(`/receipt/${this.contractId}/rectifying-invoice/pdf?month=1`)
        .then((response) => {
          window.open(response.data.temporaryLink, '_blank');
        });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
